<template>
  <v-layout class="print-body-page-layout">
    <div
      class="print-body-page-container"
      :class="[this.printPreviewPageLayout + 'Container']">
      <div
        v-if="visibility"
        class="print-body-page-inner-wrapper"
        :class="[this.printPreviewPageLayout, this.index == this.pageNum ? 'last' : '']">
        <div class="print-body-page-header" v-if="printPreviewDisplayHeader">
          <span class="header">
            Patient: <strong>{{displayPatientName()}}</strong>
          </span>
          <span class="header">
            Patient ID: <strong>{{displayPatientID()}}</strong>
          </span>
          <span class="header">
            Patient DOB: <strong>{{displayPatientDOB()}}</strong>
          </span>
        </div>
        <div v-for="num in imagesPerPage"
          v-bind:key="num"
          class="print-body-panel"
          :class="imageClass">
          <div class="imageHeader" v-if="printPreviewDisplayHeader">
            <span class="header">
              {{displayExamDate(num - 1 + indexOffset)}} {{displayImageExSrNo(num - 1 + indexOffset)}}
            </span>
          </div>
          <div class="print-body-image" 
            :style="imageStyle(num - 1 + indexOffset)"></div>
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PrintPreviewImages",
  props: {
    images: Array,
    index: Number,
    isPrinting: Boolean,
    pageNum: Number
  },
  computed: {
    ...mapGetters([
      "patient", 
      "examBySrNo", 
      "printPreviewContext", 
      "printPreviewPageLayout", 
      "printPreviewDisplayHeader", 
      "printPreviewImagesPerSheet", 
      "printPreviewCurrentPage",
      "printPreviewIsPrinting"]),
    isLoading() {
      if (this.printPreviewContext) {
        for (var i = 0; i < this.printPreviewImagesPerSheet; i++) {
          let index = ((this.index - 1) * this.printPreviewImagesPerSheet) + i;
          if (this.images[index].thumbIsLoading)
            return true;
        }
        return false;
      }
      return true;
    },
    visibility() {
      return this.index == this.printPreviewCurrentPage || this.isPrinting;
    },
    imageClass() {
      switch (this.printPreviewImagesPerSheet) {
        case 1:
          return "panel one";
        case 4:
          return "panel four";
        case 9:
          return "panel nine";
        case 16:
          return "panel sixteen";
      }
      return "panel";
    },
    pageIndex() {
      return this.index;
    },
    imagesPerPage() {
      return this.printPreviewImagesPerSheet;
    },
    indexOffset() {
      return (this.pageIndex - 1) * this.imagesPerPage;
    },
    inf(){
      return require("../../assets/INF.png");
    }
  },
  methods: {
    displayPatientName() {
      return this.patient.lastName + ", " + this.patient.firstName;
    },
    displayPatientID() {
      return this.patient.ptId;
    },
    displayPatientDOB() {
      return this.patient.dob;
    },
    displayExamDate(index) {
      // null check for intermediate objects.
      if (index > this.images.length - 1)
        return "";

      let image = this.images[index];
      if (!image)
        return "";

      let exam = this.examBySrNo(image.exSrNo);
      if (!exam)
        return "";

      let date = exam.dateDisplay || exam.date;
      if (!date)
        return "";

      return "Exam Date: " + date;
    },
    displayImageExSrNo(index) {
      if (index > this.images.length - 1)
        return "";
      let image = this.images[index];
      if (!image)
        return "";
      return "(" + this.images[index].exSrNo + ")";
    },
    imageStyle(index) {
      if (index > this.images.length - 1)
        return {
          "height": "calc(100% - 28px)"
        };
      else {
        let src = "";     
        if (this.images[index].notFound) src = this.inf;
        else src = this.images[index].imgObjectUrl || this.images[index].thumbObjectUrl;
        if (!this.printPreviewDisplayHeader) {
          return {
            "background": "no-repeat center",
            "background-image": "url('" + src + "')",
            "background-size": "contain",
            "height": "calc(100%)"
          };
        }
        else {
          return {
            "background": "no-repeat center",
            "background-image": "url('" + src + "')",
            "background-size": "contain",
            "height": "calc(100% - 28px)"
          };
        }
      }
    }
  }
};
</script>